import React, { useEffect, useRef } from "react";
import { truncate } from "lodash";

import Dropdown, { DropdownProps } from "./Dropdown";
import TextInput from "./InputField/TextInput";
import useGetProductList from "hooks/inventoryHooks/useGetProductList";
import { useAppSelector } from "hooks/storeHooks";

type ProductSelectInputProps = {
    required?: boolean;
    value: string;
    starredFilter?: string;
    autoSelectAll?: boolean;
} & DropdownProps;

export default function ProductMultiSelectInput(props: ProductSelectInputProps) {
    const { value, handleChange, required, starredFilter, autoSelectAll, ...rest } = props;
    const clearSearchRef = useRef(null);

    const { fetchedInventorySearchListSuccess } = useAppSelector((state) => state.inventory);

    const {
        productSearchList,
        handleDebouncedChangeTwo,
        handleSearchTwo,
        searchTwo,
        isLoadingMore,
        isFetchingSecondList,
        isFetching,
    } = useGetProductList(
        null,
        "Finished Goods",
        false,
        false,
        "",
        false,
        starredFilter ? starredFilter : undefined
    );

    const productValues = value?.split(",")?.filter((item) => item !== "");

    const productIds = productValues
        ?.filter((item) => item !== undefined)
        .map((item) => item?.split("-")[0])
        ?.filter((item) => item !== undefined);

    const productNames = productValues
        .map((item) => item?.split("-")[1])
        ?.filter((item) => item !== undefined);

    const isLoading = isLoadingMore || isFetchingSecondList || isFetching;

    useEffect(() => {
        if (Boolean(fetchedInventorySearchListSuccess) && autoSelectAll) {
            handleChange?.(
                props?.name || "product",
                fetchedInventorySearchListSuccess?.inventory?.data
                    ?.map((item) => item?._id + "-" + item?.productName)
                    .join(",")
            );
        }
    }, [fetchedInventorySearchListSuccess, autoSelectAll]);

    return (
        <Dropdown
            dropdown={
                <div className="flex items-center justify-between rounded-[6px] py-[6px] px-[10px] gap-2 !border !border-slate-200 max-sm:hidden">
                    <div
                        className={`text-g-75 font-rocGroteskMedium text-[11px] xs:text-[13px] inline-block whitespace-nowrap truncate`}
                    >
                        {productNames?.length > 0
                            ? truncate(productNames?.join(","), {
                                  length: 15,
                              })
                            : "All products"}
                    </div>
                    <i className="ri-arrow-down-s-line text-xs xs:text-lg text-g-75"></i>
                </div>
            }
            disabled={isLoading}
            dropdownItemsClasses="!px-0 !py-0"
            dropdownClassName="!w-full !mb-10 !-mt-7"
            dropdownContainerClasses={`shadow-cardShadow-4 border border-slate-100 right-0 rounded-[6px] !max-h-fit !w-auto`}
            loader={isLoading}
            search={
                <div ref={clearSearchRef} className="">
                    <TextInput
                        value={searchTwo}
                        name={"search"}
                        type={"text"}
                        required={false}
                        onChange={handleSearchTwo}
                        onInput={handleDebouncedChangeTwo}
                        inputPlaceholder="Search product"
                        containerClassname=""
                        inputContainerClassname="!h-[50px]"
                    />
                </div>
            }
            handleChange={(name, value) => {
                handleChange?.(name, value);
                handleSearchTwo({
                    target: {
                        value: "",
                    },
                } as React.ChangeEvent<HTMLInputElement>);
                handleDebouncedChangeTwo({
                    target: {
                        value: "",
                    },
                } as React.ChangeEvent<HTMLInputElement>);
            }}
            dropdownOptions={[
                {
                    label: (
                        <div
                            className=" text-slate-600 font-rocGroteskMedium text-[13px] flex items-center gap-2
                                border-b border-b-slate-100 !w-[190px] px-2 py-[10px]"
                        >
                            <i
                                className={`${
                                    productIds?.length === 0
                                        ? "ri-checkbox-line text-carribean-green"
                                        : "ri-checkbox-blank-line text-slate-200"
                                }    text-xl`}
                            ></i>
                            All products
                        </div>
                    ),
                    value: "",
                },
                ...productSearchList?.map((item, idx) => ({
                    label: (
                        <div
                            key={idx}
                            className=" text-slate-600 font-rocGroteskMedium text-[13px] gap-2 flex items-center
                                border-b border-b-slate-100 !w-[190px] px-2 py-[10px]"
                        >
                            <i
                                className={`${
                                    productIds?.includes(item?._id)
                                        ? "ri-checkbox-line text-carribean-green"
                                        : "ri-checkbox-blank-line text-slate-200"
                                }   text-xl`}
                            ></i>

                            <div className="flex flex-col">
                                <p className="text-xs mb-1">{` SKU: ${item?.sku}`}</p>
                                <span className="text-[10px] leading-normal">
                                    {truncate(item?.productName, {
                                        length: 50,
                                    })}
                                </span>

                                {/* <span className="text-xs">
                                            {truncate(item?.productName, {
                                                length: 38,
                                            })}
                                        </span>

                                        <p className="text-[10px]">{` SKU No: ${item?.sku}`}</p> */}
                            </div>
                        </div>
                    ),
                    value: item?._id + "-" + item?.productName,
                })),
            ]}
            {...rest}
        />
    );
}
